// extracted by mini-css-extract-plugin
export default {"fixedHeightColumn":"QkFlfK","center":"Mzyr6T","top":"NhrbNW"};